import {scaleLinear as $iilFT$scaleLinear} from "d3-scale";
import $iilFT$react, {createContext as $iilFT$createContext, useMemo as $iilFT$useMemo, useContext as $iilFT$useContext} from "react";
import $iilFT$macrostrathyper from "@macrostrat/hyper";




var $9df7cd2ff38d3f32$export$a23ea24c801a72ee = /*#__PURE__*/ function(ColumnAxisType) {
    ColumnAxisType["AGE"] = "age";
    ColumnAxisType["HEIGHT"] = "height";
    ColumnAxisType["DEPTH"] = "depth";
    ColumnAxisType["ORDINAL"] = "ordinal";
    return ColumnAxisType;
}($9df7cd2ff38d3f32$export$a23ea24c801a72ee || {});
const $9df7cd2ff38d3f32$export$c862fd4ea8e0b386 = (0, $iilFT$createContext)({
    scale: (0, $iilFT$scaleLinear)(),
    divisions: [],
    scaleClamped: (0, $iilFT$scaleLinear)().clamp(true),
    pixelsPerMeter: 1,
    zoom: 1
});
function $9df7cd2ff38d3f32$export$2c4a9b04f799f2b9(props) {
    /**
    Lays out a column on its Y (height) axis.
    This component would be swapped to provide eventual generalization to a Wheeler-diagram
    (time-domain) framework.
    */ let { children: children, pixelsPerMeter: pixelsPerMeter = 20, zoom: zoom = 1, height: height, range: range, divisions: divisions = [], width: width = 150, axisType: axisType = "height", ...rest } = props;
    // Check if "rest" actually changed
    // This is a hack to avoid re-rendering the column
    // when the "rest" props change
    const restStr = JSON.stringify(rest);
    const restRef = (0, $iilFT$react).useRef(null);
    if (restStr !== restRef.current) {
        restRef.current = restStr;
        if (Object.keys(rest).length > 0) console.warn("Passing extra properties to ColumnProvider is deprecated:", rest);
    }
    //# Calculate correct range and height
    // Range overrides height if set
    const value = (0, $iilFT$useMemo)(()=>{
        if (range != null) height = Math.abs(range[1] - range[0]);
        else range = [
            0,
            height
        ];
        // same as the old `innerHeight`
        const pixelHeight = height * pixelsPerMeter * zoom;
        const scale = (0, $iilFT$scaleLinear)().domain(range).range([
            pixelHeight,
            0
        ]);
        const scaleClamped = scale.copy().clamp(true);
        return {
            pixelsPerMeter: pixelsPerMeter,
            pixelHeight: pixelHeight,
            zoom: zoom,
            range: range,
            height: height,
            scale: scale,
            scaleClamped: scaleClamped,
            divisions: divisions,
            width: width,
            axisType: axisType,
            ...rest
        };
    }, [
        axisType,
        height,
        pixelsPerMeter,
        range,
        zoom,
        divisions,
        width,
        restRef.current
    ]);
    return (0, $iilFT$macrostrathyper)($9df7cd2ff38d3f32$export$c862fd4ea8e0b386.Provider, {
        value: value
    }, children);
}
const $9df7cd2ff38d3f32$export$ba0a914f5e13434b = ()=>(0, $iilFT$useContext)($9df7cd2ff38d3f32$export$c862fd4ea8e0b386);
const $9df7cd2ff38d3f32$export$2c18fb594663f471 = ()=>(0, $iilFT$useContext)($9df7cd2ff38d3f32$export$c862fd4ea8e0b386).divisions;


//# sourceMappingURL=column.6c3560d4.js.map
